import React, {useState} from 'react';
import {Translate} from '../../../config/TranslationProvider';
import classnames from 'classnames';
import { useAppConfiguration } from '../../../AppConfiguration';
import VideoModal from './VideoModal';
import MediaSlider from './MediaSlider';
import SingleMedia from './SingleMedia';
import BreadcrumbSingle from './BreadcrumbSingle';
import HeaderFilter from '../../filter/HeaderFilter';
import VideoConsentLayer from '../../partials/VideoConsentLayer';
import * as Klaro from 'klaro';
import getKlaroConfig from '../../../config/klaro';

export const ImageSection = ({
    media = [],
    mediaType,
    setMediaType,
    videoUrl,
    setVideoUrl,
    type,
    event = {},
    location = {},
    host = {},
    handleModalToggle,
    showModal,
}) => {

    const defaultClasses = classnames({
        'bgimage listing-details-wrapper': type !== 'filter',
        'bgimage intro-wrapper overlay overlay--dark': type === 'filter',
    });

    const imageClasses = classnames({
        ' no-image': media.length < 1
    });

    return <section
        className={defaultClasses + imageClasses}>

        {mediaType === 'video' &&
        <span className="modalToggle" onClick={handleModalToggle}>
            <div>
                <i className="la la-play-circle" />
                <span><Translate value="play" /></span>
            </div>
        </span>}

        {showModal && <VideoModal videoUrl={videoUrl} closeModal={handleModalToggle} />}

        {media.length > 1 && <MediaSlider media={media} type={type} />}

        {media.length === 1 &&
        <SingleMedia
            media={media}
            headerType={type}
            videoUrl={videoUrl}
            setVideoUrl={setVideoUrl}
            mediaType={mediaType}
            setMediaType={setMediaType}
        />}

        {type !== 'filter' &&
        <div className="listing-info content_above">
            <div className="container">
                <div className="row">
                    <BreadcrumbSingle
                        event={event && event}
                        host={host && host}
                        location={location && location}
                        type={type}
                    />
                </div>
            </div>
        </div>
        }

        {type === 'filter' &&
        <div className="directory_content_area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-10 offset-lg-1">
                        <div className="search_title_area">
                            <h1 className="title"><Translate value="main_page_title" /></h1>
                            <p className="sub_title"><Translate value="event_search_description" /></p>
                        </div>

                        <HeaderFilter />

                    </div>
                </div>
            </div>
        </div>
        }

    </section>;
}
;

export const ImageHeader = ({type = 'eventDetails', event = {}, location = {}, host = {}, header = {}}) => {
    const {isWidget, smallHeaderImage} = useAppConfiguration();

    const [videoUrl, setVideoUrl] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [mediaType, setMediaType] = useState('image');
    const [showVideoConsentLayer, setShowVideoConsentLayer] = useState(false);

    const provider = event.medialist?.[0]?.provider_name;

    const handleModalToggle = () => {
        const consentManager = Klaro.getManager(getKlaroConfig());
        const consents = consentManager.loadConsents();

        if (provider === 'vimeo' && consents.vimeo !== true) {
            setShowVideoConsentLayer(true);
            return;
        }
        if (provider === 'youtube' && consents.youtube !== true) {
            setShowVideoConsentLayer(true);
            return;
        }

        setShowModal(!showModal);
    };

    let media = [];
    switch(type) {
        case 'eventDetails':
            media = event.medialist;
            break;
        case 'hostDetails':
            media = host.medialist;
            break;
        case 'locationDetails':
            media = location.medialist;
            break;
        case 'filter':
            media = header.medialist;
            break;
        default:
            break;
    }

    if (isWidget && smallHeaderImage) {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        {showVideoConsentLayer &&
                            <VideoConsentLayer
                                provider={provider}
                                setShowVideoConsentLayer={setShowVideoConsentLayer}
                                setShowModal={setShowModal}
                            />
                        }

                        <ImageSection
                            mediaType={mediaType}
                            setMediaType={setMediaType}
                            media={media}
                            videoUrl={videoUrl}
                            setVideoUrl={setVideoUrl}
                            handleModalToggle={handleModalToggle}
                            type={type}
                            event={event}
                            host={host}
                            location={location}
                            showModal={showModal}
                        />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            {showVideoConsentLayer &&
                <VideoConsentLayer
                    provider={provider}
                    setShowVideoConsentLayer={setShowVideoConsentLayer}
                    setShowModal={setShowModal}
                />
            }

            <ImageSection
                mediaType={mediaType}
                setMediaType={setMediaType}
                media={media}
                videoUrl={videoUrl}
                setVideoUrl={setVideoUrl}
                handleModalToggle={handleModalToggle}
                type={type}
                event={event}
                host={host}
                location={location}
                showModal={showModal}
            />
        </>
    );
};

export default ImageHeader;
